<template>
  <div class="footer">
    <v-card color="background" min-height="196" flat>
      <v-container class="py-5 px-4 px-md-3">
        <v-row>
          <!-- Left -->
          <v-col cols="12" md="4">
            <div class="d-flex">
              <router-link :to="{ name: 'HomePage' }">
                <v-img
                  alt="Logo"
                  class="logo"
                  contain
                  src="@/assets/img/public/shared/logos/logo2.png"
                />
              </router-link>
            </div>

            <p class="mt-4 mt-md-11 b-caption gray700--text">
              © 2023. Century Financial Services (PTY) LTD <br />
              Company Registration Number 2023/140135/07 <br />

              Registred with the National Credit Regulator - Registration Number
              NCRCP20790
            </p>
          </v-col>

          <!-- Center -->
          <v-col cols="12" md="4" class="mt-n7 mt-md-0">
            <p class="b-caption gray700--text">
              Our site uses cookies to provide services in accordance with the
              Privacy Policy. By using this site, you agree to our use of
              cookies
            </p>
            <p class="b-caption gray700--text mb-2 mt-2">
              1 Bridgeway Road, Bridgeways Precinct, Century City, Cape Town,
              7441
            </p>

            <v-row class="pa-3">
              <v-col cols="12" md="6" class="ma-0 pa-0">
                <div>
                  <router-link
                    :to="{ name: 'PrivacyPolicyPage' }"
                    class="b-caption primary--text text-decoration-none"
                  >
                    Privacy Policy
                  </router-link>
                </div>
                <div>
                  <a
                    :href="refundPolicyUrl"
                    class="b-caption primary--text text-decoration-none"
                    target="_blank"
                  >
                    Refund Policy
                  </a>
                </div>
                <div>
                  <a
                    :href="languagePolicyUrl"
                    class="b-caption primary--text text-decoration-none"
                    target="_blank"
                  >
                    Language Policy
                  </a>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="ma-0 pa-0">
                <div>
                  <a
                    :href="termsAndConditionsUrl"
                    class="b-caption primary--text text-decoration-none"
                    target="_blank"
                  >
                    Terms and Conditions
                  </a>
                </div>
                <div>
                  <router-link
                    :to="{ name: 'ResponsibleLendingPage' }"
                    class="b-caption primary--text text-decoration-none"
                  >
                    Responsible Lending
                  </router-link>
                </div>
                <div>
                  <a
                    :href="PAIAManualUrl"
                    class="b-caption primary--text text-decoration-none"
                    target="_blank"
                  >
                    PAIA Manual
                  </a>
                </div>
                <div>
                  <a
                    :href="accessRequestFormUrl"
                    class="b-caption primary--text text-decoration-none"
                    target="_blank"
                  >
                    Access Request Form
                  </a>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <!-- Right -->
          <v-col cols="12" md="4" class="mt-n4 mt-md-0">
            <!-- Email -->
            <div class="d-flex">
              <a
                href="mailto:clientsupport@centuryfinancialservices.net"
                class="text-decoration-none"
                target="_blank"
              >
                <div class="d-flex align-center">
                  <!-- <v-img alt="Envelope" class="envelope" contain src="@/assets/img/public/shared/footer/envelope.svg"
                    max-width="20" /> -->
                  <v-icon color="#08338F">mdi-email-outline</v-icon>

                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium ml-2 d-inline d-md-none"
                  >
                    clientsupport@centuryfinancialservices.net
                  </a>

                  <!-- Desktop Only -->
                  <a
                    href="mailto:clientsupport@centuryfinancialservices.net"
                    class="text-decoration-none font-weight-medium d-none d-md-inline"
                  >
                    clientsupport@centuryfinancialservices.net
                  </a>
                </div>
              </a>
            </div>

            <!-- Phone -->
            <div class="d-flex mt-2">
              <a
                href="tel:+27210541057"
                class="text-decoration-none"
                target="_blank"
              >
                <div
                  class="d-flex align-center text-decoration-none font-weight-medium"
                >
                  <!-- <v-img alt="Call" class="call" contain src="@/assets/img/public/shared/footer/phone.svg"
                    max-width="18" /> -->
                  <v-icon color="#08338F">mdi-phone</v-icon>

                  <h6 class="b-subtitle-1 ml-2 primary--text">
                    +27 21 054 1057
                  </h6>
                </div>
              </a>
            </div>

            <!-- Facebook and Youtube -->
            <div class="d-flex my-4">
              <!-- Facebook -->
              <a
                href="https://www.facebook.com/"
                class="text-decoration-none"
                target="_blank"
              >
                <v-img
                  alt="Facebook"
                  class="facebook"
                  contain
                  src="@/assets/img/public/shared/footer/facebook.svg"
                  max-width="18"
                />
              </a>

              <!-- Youtube -->
              <a
                href="https://www.youtube.com/"
                class="text-decoration-none"
                target="_blank"
              >
                <v-img
                  alt="Youtube"
                  class="youtube ml-6 mt-1"
                  contain
                  src="@/assets/img/public/shared/footer/youtube.svg"
                  max-width="20"
                />
              </a>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "LimeLoansTheFooter",

  data() {
    return {
      PAIAManualUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Century Financial Services PAIA Manual.pdf",
      languagePolicyUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Century Financial Services Language Policy V1 -30 June 2025.pdf",
      accessRequestFormUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Century Financial Services (Pty) Ltd - Access Request Form.pdf",
      privacyPolicyUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Century Financial Services Privacy Policy for Website.pdf",
      termsAndConditionsUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Website Terms and Conditions and Disclaimer.pdf",
      refundPolicyUrl:
        process.env.VUE_APP_APP_URL +
        "/assets/docs/Century Financial Services (Pty) Ltd - Refund Policy V1.pdf",
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
  .logo {
    width: 100%;
    width: 180px;
    height: auto;
  }

  @media only screen and (max-width: 768px) {
    .header-card {
      height: 52px;

      .logo {
        width: 120px;
      }
    }
  }

  @media (max-width: 480px) {
    .logo {
      width: 120px;
    }
  }

  @media only screen and (max-width: 600px) {
    .logo {
      width: 120px;
    }
  }
}
</style>
